/* eslint-disable no-lone-blocks */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */

// eslint-disable-next-line camelcase, max-len
const s_actionFilePath = 'data:/../apps/NRE/models/skeletonModel/actions'
const visualizationConfig = Wiz.globalSettings.globalConfig?.visualizationConfig || {}
// eslint-disable-next-line camelcase
const s_actionData = [
  {
    name: 'idle',
    file: 'Idle.fbx', // 待机
  },
  {
    name: 'walk',
    file: 'Walking.fbx', // 行走
  },
  {
    name: 'run',
    file: 'Running.fbx', // 跑
  },
]
// 轨道类型枚举
const EnumKFTTDouble = 1 // double类型
const EnumKFTTReal3 = 3 // 三维向量(double3)类型
const EnumKFTTQuaternion = 5 // 四元数(quat<double>)类型

// 轨道属性链接类型枚举
const EnumAPBTTranslation = 1 // 位置属性绑定
const EnumAPBTRotation = 2 // 旋转属性绑定
const EnumAPBTScaling = 3 // 缩放属性绑定
// 节点的类型集合
const EnumObjectTypes = [
  'modelFile', // 模型类型
  'dynamicEffects',
]
const actionList = []
// 生成guid
const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}
const isJSONObj = (str) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj && Object.keys(obj).length) {
        // typeof null 也为 object
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }
  return false
}

// 加载模型
const loadModel = async (file, name, parentNode, player) => {
  const modelNode = await player.Native.NodeProxy.loadModelNode(parentNode, file, name)
  return modelNode
}
// 加载模型
const loadPrModel = async (file, name, parentNode, player) => {
  await player.Native.Model.loadModel(name, file)
  const modelInfo = await player.Native.Model.getInfo(name)
  await player.Native.NodeProxy.setNodeParent(modelInfo.nodePtr, parentNode)
  return modelInfo.nodePtr
}
// 加载粒子节点
const loadParticle = async (file, name, parentNode, player) => {
  const particleNode = await player.Native.ParticleEffekseer.createParticle(file)
  await player.Native.NodeProxy.setNodeInfo(particleNode, { name })
  await player.Native.NodeProxy.setNodeParent(particleNode, parentNode)
  return particleNode
}
// 加载人物模型
const loadAnimationClipTemplates = async (actionFilePath, actionData, player) => {
  if (actionList && actionList.length > 0) return actionList

  for (let i = 0; i < actionData.length; i += 1) {
    const file = `${actionFilePath}/${actionData[i].file}`
    const isExist = await player.Native.File.exists(file)
    if (isExist) {
      const action = await player.Native.SkeletonNode.loadSkeletonNodeAnimationData(file)
      player.Native.AnimationClip.setName(action, actionData[i].name)
      actionList.push(action)
    } else {
      // console.log(file, '文件未找到')
    }
  }
  return actionList
}
// 加载人物模型
const loadPersonAnimation = async (file, name, parentNode, player) => {
  const personNode = await player.Native.SkeletonNode.loadSkeletonNode(file)
  await player.Native.NodeProxy.setNodeInfo(personNode, { name })
  await player.Native.NodeProxy.setNodeParent(personNode, parentNode)
  // 将动作附加到人物模型上
  const manBones = await player.Native.SkeletonNode.bones(personNode)
  const manMixer = await player.Native.SkeletonNode.mixer(personNode) /*  */
  // 从动作库中复制人物动作
  const srcClips = await loadAnimationClipTemplates(s_actionFilePath, s_actionData, player)
  // 关联动作片段
  const newClips = await player.Native.AnimationClip.cloneClipsAddAttachTrackDataNames(
    srcClips,
    manBones
  )
  // 添加动作片段到人物模型的动画混合器上
  await player.Native.AnimationClip.addClips(manMixer, newClips)
  // 获取 待机 动作控制器，播放人物待机动作
  const defaultClipAction = await player.Native.AnimationAction.clipAction(manMixer, 'idle')
  await player.Native.AnimationAction.fadeIn(defaultClipAction, 1.0)
  return personNode
}
// 加载工程
const loadEngineer = async (config, parentNode, player) => {
  const currentFileData = _.find(config.fileList, ['type', 'engineering'])
  await player.Native.NodeProxy.openProject(currentFileData.targetUrl)
  const rootItem = await player.Native.ModelTree.getRootItems()
  const currentProjectData = _.find(rootItem, (el) => {
    return el.name === currentFileData.fileId
  })
  if (currentProjectData) {
    await player.Native.NodeProxy.setNodeParent(currentProjectData.nodePtr, parentNode)
    await player.Native.NodeProxy.setNodeInfo(currentProjectData.nodePtr, {
      code: JSON.stringify(config),
    })
    // 加载动画
    const currentAnimationFileData = _.find(config.fileList, ['type', 'animation'])
    const animationGroup = await player.Native.AnimationMgr.createGroup('pprjAnimation')
    setTimeout(async () => {
      await player.Native.AnimationMgr.importAniminationFile(
        animationGroup,
        currentProjectData.nodePtr,
        currentAnimationFileData.targetUrl
      )
      if (config.animationConfig.autoPlay) {
        await player.Native.AnimationMgr.start(animationGroup)
      } else {
        await player.Native.AnimationMgr.stop(animationGroup)
      }
      await player.Native.AnimationMgr.setLoop(animationGroup, config.animationConfig.playTimes)
      await player.Native.AnimationMgr.setSpeed(animationGroup, config.animationConfig.speed)
    }, 1000)
  }
}
const loadSceneFromJson = async (
  obj,
  parentNode,
  player,
  sceneOptions = {
    isEnableGis: false,
    latitude: 0,
    longitude: 0,
  },
  nodes = [],
  loadCallback = () => {},
  collisionReload = false
) => {
  // const fileType = obj.code.fileType
  let node = null
  // 根据节点类型，序列化某些特有类型的节点数据
  switch (obj.code.type) {
    case 'modelFile':
      const fileType = _.last(obj.code.filePath.split('.'))
      if (collisionReload) {
        node = await loadModel(obj.code.filePath, obj.name, parentNode, player)
      } else if (visualizationConfig.loadInterface !== 'Node' && fileType === 'pr') {
        node = await loadPrModel(obj.code.filePath, obj.code.id, parentNode, player)
      } else {
        node = await loadModel(obj.code.filePath, obj.name, parentNode, player)
      }
      break
    case 'dynamicEffects':
      node = await loadParticle(obj.code.filePath, obj.name, parentNode, player)
      break
    case 'engineering':
      node = await loadEngineer(obj.code, parentNode, player)
      break
    default:
      // 层级节点，直接根据名称创建节点
      node = await player.Native.NodeProxy.createNode(parentNode, obj.name)
      break
  }
  nodes.push({ type: obj.code.type, nodePtr: node })
  loadCallback(nodes)
  // 节点创建失败，返回nullptr
  if (node !== null && node !== 0) {
    if (obj.code.type === 'Root' && !sceneOptions.isEnableGis) {
      obj.code.isEnableGis = false
      await player.Native.NodeProxy.setLocalTranslation(node, [0, 0, 0])
    } else if (
      obj.code.type === 'Root' &&
      sceneOptions.isEnableGis &&
      sceneOptions.longitude &&
      sceneOptions.latitude
    ) {
      const elevation = (
        await player.Native.GisPlatform.queryDEM([
          [sceneOptions.longitude, sceneOptions.latitude, 0],
        ])
      )[0]
      await player.Native.NodeProxy.setNodeGisPos(node, [
        sceneOptions.longitude,
        sceneOptions.latitude,
        elevation,
      ])
      obj.code.isEnableGis = true
    } else {
      await player.Native.NodeProxy.setLocalTranslation(node, obj.localPosition)
    }
    await player.Native.NodeProxy.setLocalRotation(node, obj.localRotation)
    await player.Native.NodeProxy.setLocalScaling(node, obj.localScaling)
    // 设置节点属性
    await player.Native.NodeProxy.setNodeInfo(node, {
      name: obj.name,
      code: JSON.stringify(obj.code),
      id: obj.guid,
    })
    // 递归子，继续创建
    if (obj.children && obj.children.length) {
      for (let i = 0; i < obj.children.length; ++i) {
        await loadSceneFromJson(
          obj.children[i],
          node,
          player,
          sceneOptions,
          nodes,
          loadCallback,
          collisionReload
        )
      }
    }
  }
  return nodes
}
// 保存场景到json对象
const saveSceneToJson = async (node, player) => {
  if (!node) return null
  const obj = {}
  // 序列化节点的基本信息
  const nodeInfo = await player.Native.NodeProxy.getNodeInfo(node)
  obj.name = nodeInfo.name
  obj.code = nodeInfo.code ? JSON.parse(nodeInfo.code) : ''
  obj.guid = nodeInfo.id
  // 序列化节点的变换信息
  obj.localPosition = await player.Native.NodeProxy.localTranslation(node)
  obj.localRotation = await player.Native.NodeProxy.localRotation(node)
  obj.localScaling = await player.Native.NodeProxy.localScaling(node)
  // 根据节点类型，序列化某些特有类型的节点数据
  if (obj.code.type) {
    const modelChildren = await player.Native.NodeProxy.getNodeChildren(node)
    const modelChild = _.filter(modelChildren, (item) => {
      return item.code && isJSONObj(item.code) && JSON.parse(item.code).type
    })
    if (!_.isEmpty(modelChild)) {
      obj.children = []
      for (let i = 0; i < modelChild.length; i += 1) {
        const childObj = await saveSceneToJson(modelChild[i].nodePtr, player)
        if (childObj) {
          obj.children.push(childObj)
        }
      }
    }
    return obj
  }
  // 层级节点，需要继续递归
  obj.children = []
  const childrenInfos = await player.Native.NodeProxy.getNodeChildren(node)
  const filterChilds = _.filter(childrenInfos, (el) => {
    return el.code
  })
  for (let i = 0; i < filterChilds.length; ++i) {
    const childObj = await saveSceneToJson(filterChilds[i].nodePtr, player)
    if (childObj != null) obj.children.push(childObj)
  }
  return obj
}
// 通过指定节点去查下面的子节点 nodeType 指定节点的类型，obj 需要筛选的对象数据源，arr 接收筛选后的数据集合
const getNodesByNodeType = async (obj, arr = []) => {
  // let currentNodeType = obj.code && obj.code.type
  const currentNodeType = obj?.code?.type
  if (EnumObjectTypes.includes(currentNodeType)) {
    const nowObj = _.cloneDeep(obj)
    delete nowObj.children
    arr.push(nowObj)
  }
  // 递归子，继续创建
  if (obj.children && obj.children.length) {
    for (let i = 0; i < obj.children.length; ++i) {
      await getNodesByNodeType(obj.children[i], arr)
    }
  }
  return arr
}
const getPoint = (p0, p1, t) => {
  return [p0[0] + (p1[0] - p0[0]) * t, p0[1] + (p1[1] - p0[1]) * t, p0[2] + (p1[2] - p0[2]) * t]
}
const loadAction = async (data, node, config, player, flag) => {
  // 创建路径动画混合器
  const mixer = await player.Native.AnimationMixer.getMixer('review')
  const clip = await player.Native.AnimationClip.getClip(mixer, 'review')
  const action = await player.Native.AnimationAction.clipAction(mixer, clip)
  const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
  if (clipTrackCount > 0) {
    await player.Native.KeyframeTrack.clearTrack(clip)
  }
  if (!flag) {
    return null
  }
  // 创建位置关键帧轨道
  const trackT = await player.Native.KeyframeTrack.addTrackWithParam(clip, node, {
    name: 'trackLocalTranslation',
    trackType: EnumKFTTReal3,
    propertyLinkType: EnumAPBTTranslation,
  })

  // 根据路径顶点添加位置关键帧
  await player.Native.KeyframeTrack.keyClear(trackT)
  if (!flag) {
    return null
  }
  // 创建旋转关键帧轨道
  const trackR = await player.Native.KeyframeTrack.addTrackWithParam(clip, node, {
    name: 'trackLocalRotation',
    trackType: EnumKFTTQuaternion,
    propertyLinkType: EnumAPBTRotation,
  })
  await player.Native.KeyframeTrack.keyClear(trackR)
  if (!flag) {
    return null
  }
  // 创建缩放关键帧轨道
  const trackS = await player.Native.KeyframeTrack.addTrackWithParam(clip, node, {
    name: 'trackLocalScaling',
    trackType: EnumKFTTReal3,
    propertyLinkType: EnumAPBTScaling,
  })
  let time = 0
  await player.Native.KeyframeTrack.keyClear(trackS)
  for (let i = 0; i < data.length; i += 1) {
    const item = data[i]
    const animationData = JSON.parse(item.properties)
    // 计算当前关键帧时间
    if (i > 0) {
      const lastAnimationData = JSON.parse(data[i - 1].properties)
      const v = config.speed * 1
      // 加速阶段的初速度
      const v0 = v * 0.2
      // 两个关键点之间的总距离(路程)
      const s = Vec3.length(Vec3.sub(lastAnimationData.localPosition, animationData.localPosition))
      // 加速阶段的距离
      const s1 = s * 0.2
      if (config.speedCurve === 2) {
        const hastenEndPoint = getPoint(
          lastAnimationData.localPosition,
          animationData.localPosition,
          0.2
        )
        const decelerateBeginPoint = getPoint(
          lastAnimationData.localPosition,
          animationData.localPosition,
          0.8
        )
        // 计算加速阶段时长
        time += s1 / v0
        // // 加速过程
        await player.Native.KeyframeTrack.keyAppend(trackT, time, hastenEndPoint)
        // 匀速过程
        time += (s - 2 * s1) / v
        // 添加位置关键帧
        await player.Native.KeyframeTrack.keyAppend(trackT, time, decelerateBeginPoint)
        // 减速过程
        time += s1 / v0 || v0
      } else if (config.speedCurve === 1) {
        const hastenEndPoint = getPoint(
          JSON.parse(data[0].properties).localPosition,
          JSON.parse(data[1].properties).localPosition,
          0.2
        )
        const decelerateBeginPoint = getPoint(
          JSON.parse(data[data.length - 2].properties).localPosition,
          JSON.parse(data[data.length - 1].properties).localPosition,
          0.8
        )
        if (i === 1) {
          // 加速过程
          // 计算加速阶段时长
          time += s1 / v0
          await player.Native.KeyframeTrack.keyAppend(trackT, time, hastenEndPoint)
          // 匀速过程
          time += (s - s1) / v || v
        } else if (i === data.length - 1) {
          // 减速过程
          time += (s - s1) / v
          await player.Native.KeyframeTrack.keyAppend(trackT, time, decelerateBeginPoint)
          time += s1 / v0 || v0
        } else {
          // 匀速过程
          time += s / v || v
        }
      } else {
        time += s / v || v
      }
    }
    // 添加位置关键帧
    await player.Native.KeyframeTrack.keyAppend(trackT, time, animationData.localPosition)
    // 添加旋转关键帧
    const localRotation = EulerAngle.fromQuat(animationData.localRotation)
    const rotMat = EulerAngle.toRotationMatrix(localRotation)
    const quat = Matrix4.decompose(rotMat).quaternion
    await player.Native.KeyframeTrack.keyAppend(trackR, time, quat)
    // 添加缩放关键帧
    await player.Native.KeyframeTrack.keyAppend(trackS, time, animationData.localScaling)
  }
  const lastStatus = JSON.parse(data[data.length - 1].properties)
  const rotationQuat = EulerAngle.fromQuat(lastStatus.localRotation)
  const rotMat = EulerAngle.toRotationMatrix(rotationQuat)
  lastStatus.localRotation = Matrix4.decompose(rotMat).quaternion
  if (config.loopType === 2) {
    const TKeys = await player.Native.KeyframeTrack.keys(trackT)
    const RKeys = await player.Native.KeyframeTrack.keys(trackR)
    const SKeys = await player.Native.KeyframeTrack.keys(trackS)
    const TKeysReverse = TKeys.reverse()
    const RKeysReverse = RKeys.reverse()
    const SKeysReverse = SKeys.reverse()
    let TReverseTime = TKeysReverse[0].time
    let RReverseTime = RKeysReverse[0].time
    let SReverseTime = SKeysReverse[0].time
    lastStatus.localPosition = TKeysReverse[TKeysReverse.length - 1].value
    lastStatus.localRotation = RKeysReverse[RKeysReverse.length - 1].value
    lastStatus.localScaling = SKeysReverse[SKeysReverse.length - 1].value
    for (let i = 0; i < TKeysReverse.length; i += 1) {
      if (i > 0) {
        TReverseTime += TKeysReverse[i - 1].time - TKeysReverse[i].time
        await player.Native.KeyframeTrack.keyAppend(trackT, TReverseTime, TKeysReverse[i].value)
      }
    }
    for (let i = 0; i < RKeysReverse.length; i += 1) {
      if (i > 0) {
        RReverseTime += RKeysReverse[i - 1].time - RKeysReverse[i].time
        await player.Native.KeyframeTrack.keyAppend(trackR, RReverseTime, RKeysReverse[i].value)
      }
    }
    for (let i = 0; i < SKeysReverse.length; i += 1) {
      if (i > 0) {
        SReverseTime += SKeysReverse[i - 1].time - SKeysReverse[i].time
        await player.Native.KeyframeTrack.keyAppend(trackS, SReverseTime, SKeysReverse[i].value)
      }
    }
    time = _.max([TReverseTime, RReverseTime, SReverseTime])
  }
  if (config.loopInterval && !_.isEmpty(data) && config.loopType !== 0) {
    await player.Native.KeyframeTrack.keyAppend(
      trackT,
      time + config.loopInterval * 1,
      lastStatus.localPosition
    )
    await player.Native.KeyframeTrack.keyAppend(
      trackR,
      time + config.loopInterval * 1,
      lastStatus.localRotation
    )
    await player.Native.KeyframeTrack.keyAppend(
      trackS,
      time + config.loopInterval * 1,
      lastStatus.localScaling
    )
  }
  await player.Native.AnimationAction.setLoop(action, config.loopType, -1)
  await player.Native.AnimationAction.bindActionUpdate(action)
  player.Native.AnimationAction.play(action)
  return action
}
export {
  saveSceneToJson,
  loadSceneFromJson,
  isJSONObj,
  loadModel,
  getNodesByNodeType,
  generateGUID,
  loadParticle,
  loadAction,
  EnumObjectTypes,
}
